import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const HolidayGreeting = ({ theme }) => {
  const [currentGreeting, setCurrentGreeting] = useState(0);

  const greetings = {
    christmas: [
      { text: "Joyeux Noël !", emoji: "🎄" },
      { text: "Ho Ho Ho !", emoji: "🎅" },
      { text: "Meilleurs Vœux !", emoji: "🎁" },
      { text: "Joie et Bonheur !", emoji: "⭐" }
    ],
    winter: [
      { text: "Féerie Hivernale !", emoji: "❄️" },
      { text: "Qu'il neige !", emoji: "🌨️" },
      { text: "Joyeux Hiver !", emoji: "⛄" },
      { text: "Chaleureux Vœux !", emoji: "🔥" }
    ],
    'new-year': [
      { text: "Bonne Année !", emoji: "🎊" },
      { text: "Santé et Bonheur !", emoji: "🥂" },
      { text: "Bienvenue 2024 !", emoji: "✨" },
      { text: "Nouvelle Année !", emoji: "🎆" }
    ],
    hanukkah: [
      { text: "Joyeux Hanoucca !", emoji: "🕎" },
      { text: "Fête des Lumières !", emoji: "🕯️" },
      { text: "8 Nuits de Joie !", emoji: "✡️" },
      { text: "Hanoucca Sameach !", emoji: "💙" }
    ]
  };

  const currentGreetings = greetings[theme] || greetings.christmas;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGreeting((prev) => (prev + 1) % currentGreetings.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [currentGreetings.length]);

  return (
    <div className="mb-8 text-center">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentGreeting}
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -20, scale: 0.8 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="flex flex-col items-center gap-4"
        >
          <motion.div
            animate={{ 
              rotate: [0, 10, -10, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{ 
              duration: 2, 
              repeat: Infinity, 
              repeatDelay: 2 
            }}
            className="text-8xl"
          >
            {currentGreetings[currentGreeting].emoji}
          </motion.div>
          
          <motion.h1
            animate={{ 
              textShadow: [
                '0 0 20px rgba(255,255,255,0.5)',
                '0 0 40px rgba(255,255,255,0.8)',
                '0 0 20px rgba(255,255,255,0.5)'
              ]
            }}
            transition={{ 
              duration: 2, 
              repeat: Infinity, 
              ease: "easeInOut" 
            }}
            className="text-4xl md:text-6xl font-bold text-white mb-2"
          >
            {currentGreetings[currentGreeting].text}
          </motion.h1>
        </motion.div>
      </AnimatePresence>

      {/* Floating sparkles */}
      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute text-2xl"
          animate={{
            x: [0, Math.random() * 100 - 50],
            y: [0, Math.random() * 100 - 50],
            opacity: [0, 1, 0],
            scale: [0, 1, 0]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            delay: i * 0.5,
            ease: "easeInOut"
          }}
          style={{
            left: `${20 + Math.random() * 60}%`,
            top: `${20 + Math.random() * 60}%`
          }}
        >
          ✨
        </motion.div>
      ))}
    </div>
  );
};

export default HolidayGreeting;